export { pgCollapseComponent } from './collapse.component';
export { pgCollapsesetComponent } from './collapseset.component';
export { pgCollapseModule } from './collapse.module';


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/collapse/index.ts